module.exports = {"ru":{"nextBtn":"Далее","prevBtn":"Назад","doneBtn":"Готово","skipBtn":"Пропустить все","closeTooltip":" "},"en":{"nextBtn":"Next","prevBtn":"Previous","doneBtn":"Done","skipBtn":"Skip","closeTooltip":" "}}


//////////////////
// WEBPACK FOOTER
// ./temp/components/tour/.variant/base/text.yaml
// module id = 242
// module chunks = 0